// extracted by mini-css-extract-plugin
export var button = "C2Cff";
export var icon = "YWXus";
export var root = "lkc1w";
export var shifted = "X1i+p";
export var text = "_8KIBP";